module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_8003.dbe41d83.png";